import { render, staticRenderFns } from "./EditYaml.vue?vue&type=template&id=6c5a6eb0&scoped=true&"
import script from "./EditYaml.vue?vue&type=script&lang=js&"
export * from "./EditYaml.vue?vue&type=script&lang=js&"
import style0 from "./EditYaml.vue?vue&type=style&index=0&id=6c5a6eb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a6eb0",
  null
  
)

export default component.exports